/**
 * Flaire — Filter & Sort luxury redesign
 * Syncs a live result count into the sheet's primary CTA button
 * ("View 42 Results" instead of a static "Apply"). Purely additive: reads
 * #FrFilterCount, which Dawn's own facets.js already keeps in sync on every
 * AJAX filter change via renderAdditionalElements() (it matches by the
 * .mobile-facets__count class, which is preserved on that element). This
 * file never touches facets.js or the AJAX submit/render contract.
 */
(function () {
  function extractCount(text) {
    if (!text) return null;
    var match = text.replace(/,/g, '').match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function formatLabel(count) {
    if (count === null) return 'View Results';
    if (count === 0) return 'Show 0 Results';
    return 'View ' + count.toLocaleString() + (count === 1 ? ' Result' : ' Results');
  }

  function sync() {
    var countEl = document.getElementById('FrFilterCount');
    var ctaLabel = document.getElementById('FrFilterApplyLabel');
    if (!countEl || !ctaLabel) return;
    ctaLabel.textContent = formatLabel(extractCount(countEl.textContent));
  }

  function init() {
    var countEl = document.getElementById('FrFilterCount');
    if (!countEl) return;

    sync();

    var observer = new MutationObserver(function () {
      sync();
    });
    observer.observe(countEl, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Size grouping — merges duplicate-spelling size options (e.g. "7 Inches"
 * and "7 INCH", which Shopify treats as two distinct filter values because
 * the underlying product data uses inconsistent formatting) into a single
 * visual chip, and clusters the remaining options into "Ring Size" /
 * "Length" / "Width" sub-groups so genuinely different size types never
 * read as one scattered row.
 *
 * Purely a presentation layer: every real <input class="mobile-facets__checkbox">
 * stays in the DOM with its original name/value, so Dawn's facets.js AJAX
 * contract is untouched. The merged chip's checkbox simply mirrors its
 * checked state onto the other checkboxes it represents and dispatches one
 * real "input" event from a genuine .mobile-facets__checkbox element, which
 * is exactly what facets.js already listens for.
 *
 * Dawn re-renders each filter's markup from scratch on every AJAX update, so
 * this re-runs via a MutationObserver every time the size filter's chip list
 * changes, and disconnects itself while it is the one doing the mutating to
 * avoid reprocessing its own output.
 */
(function () {
  function normalizeKey(text) {
    var s = (text || '').trim().toLowerCase().replace(/\s+/g, '');
    s = s.replace(/inches\b/, 'in').replace(/inch\b/, 'in');
    s = s.replace(/["″]/g, 'in').replace(/''/g, 'in');
    return s;
  }

  function clusterKey(normKey) {
    if (/mm$/.test(normKey)) return 'width';
    if (/in$/.test(normKey)) return 'length';
    if (/^\d+(\.\d+)?$/.test(normKey)) return 'ring';
    return 'other';
  }

  var CLUSTER_LABELS = { ring: 'Ring Size', length: 'Length', width: 'Width' };
  var CLUSTER_ORDER = ['ring', 'length', 'width'];

  function chipText(item) {
    var el = item.querySelector('.fr-filter-chip__text, .fr-filter-chip__caption');
    return el ? el.textContent : '';
  }

  function processList(list) {
    if (!list) return;

    // Safety valve: merging two spellings into one chip works by checking
    // both underlying checkboxes at once, which only produces the intended
    // "match either" result when the filter uses OR semantics (the norm for
    // a Size/variant-option filter). If a filter is explicitly configured
    // AND, checking two values would require a single product to match both
    // simultaneously — skip merging there and only apply the sub-clustering.
    var filterGroup = list.closest('.fr-filter-group');
    var allowMerge = !filterGroup || filterGroup.dataset.operator !== 'AND';

    // Idempotent: strip any subheads from a previous run on this same node
    // before recomputing, so repeated runs never pile up duplicates.
    Array.prototype.slice.call(list.querySelectorAll('.fr-filter-chips__subhead')).forEach(function (el) {
      el.remove();
    });

    var items = Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList && el.classList.contains('fr-filter-chip-item');
    });
    if (!items.length) return;

    // Capture each item's original count once, so re-running this function
    // on the same (unreplaced) DOM never sums an already-merged total.
    items.forEach(function (item) {
      item.hidden = false;
      var countEl = item.querySelector('.fr-filter-chip__count');
      if (countEl && item.dataset.frOrigCount === undefined) {
        item.dataset.frOrigCount = countEl.textContent.replace(/[^\d]/g, '') || '0';
      }
    });

    // --- merge duplicate spellings into one representative chip ---
    var groups = {};
    var order = [];
    if (allowMerge) {
      items.forEach(function (item) {
        var key = normalizeKey(chipText(item));
        if (!key) return;
        if (!groups[key]) {
          groups[key] = [];
          order.push(key);
        }
        groups[key].push(item);
      });
    }

    order.forEach(function (key) {
      var members = groups[key];
      if (members.length <= 1) return;

      var rep = members[0];
      for (var i = 0; i < members.length; i++) {
        var t = chipText(members[i]);
        if (t && t !== t.toUpperCase()) {
          rep = members[i];
          break;
        }
      }

      var totalCount = 0;
      members.forEach(function (m) {
        var n = parseInt(m.dataset.frOrigCount, 10);
        if (!isNaN(n)) totalCount += n;
        if (m !== rep) m.hidden = true;
      });

      var repCountEl = rep.querySelector('.fr-filter-chip__count');
      if (repCountEl && totalCount > 0) repCountEl.textContent = totalCount;

      var repInput = rep.querySelector('.mobile-facets__checkbox');
      if (repInput && !repInput.dataset.frGrouped) {
        repInput.dataset.frGrouped = '1';
        repInput.addEventListener('change', function () {
          members.forEach(function (m) {
            if (m === rep) return;
            var input = m.querySelector('.mobile-facets__checkbox');
            if (input && input.checked !== repInput.checked) {
              input.checked = repInput.checked;
            }
          });
        });
      }
    });

    // --- cluster the surviving chips into Ring Size / Length / Width ---
    var clustersPresent = {};
    items.forEach(function (item) {
      if (item.hidden) return;
      var c = clusterKey(normalizeKey(chipText(item)));
      if (CLUSTER_LABELS[c]) clustersPresent[c] = true;
    });

    if (Object.keys(clustersPresent).length > 1) {
      CLUSTER_ORDER.forEach(function (c) {
        if (!clustersPresent[c]) return;
        var firstOfCluster = items.filter(function (item) {
          return !item.hidden && clusterKey(normalizeKey(chipText(item))) === c;
        })[0];
        if (!firstOfCluster) return;
        var head = document.createElement('li');
        head.className = 'fr-filter-chips__subhead';
        head.textContent = CLUSTER_LABELS[c];
        head.setAttribute('aria-hidden', 'true');
        list.insertBefore(head, firstOfCluster);
      });
    }
  }

  function processAll(observer) {
    if (observer) observer.disconnect();
    var lists = document.querySelectorAll('.fr-filter-group--size .fr-filter-chips');
    Array.prototype.forEach.call(lists, processList);
    if (observer) observer.observe(observer.__frTarget, { childList: true, subtree: true });
  }

  function init() {
    var target = document.getElementById('FacetsWrapperMobile');
    if (!target || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      processAll(observer);
    });
    observer.__frTarget = target;

    processAll(observer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
